import { ROUTES_BASE } from '../../config/routes';

export const getNestedRoute = (relativePath) =>
  relativePath.startsWith(ROUTES_BASE) ? relativePath.replace(ROUTES_BASE, '') : relativePath;
